export interface ICreateQueueUrlModel {
  doctorID: string;
}

export class CreateQueueUrlModel {
  constructor(data?: ICreateQueueUrlModel) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property)) {
          ( this as any)[property] = (data as any)[property];
        }
      }
    }
  }
}
